import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Import your language files
import en from "./en.json";
import tr from "./tr.json";

i18n
  .use(LanguageDetector) // Automatically detect user language
  .use(initReactI18next) // Bind react-i18next to i18next
  .init({
    resources: {
      en: { translation: en },
      tr: { translation: tr },
    },
    fallbackLng: "tr", // Use English if detected language is not available
    interpolation: {
      escapeValue: false, // React already does escaping
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n;
